import { render, staticRenderFns } from "./ConfigPcLogReport.vue?vue&type=template&id=b8228dc4&scoped=true"
import script from "./ConfigPcLogReport.vue?vue&type=script&lang=js"
export * from "./ConfigPcLogReport.vue?vue&type=script&lang=js"
import style0 from "./ConfigPcLogReport.vue?vue&type=style&index=0&id=b8228dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8228dc4",
  null
  
)

export default component.exports